import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/turbooghost/Coding/cpl-webiste/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/turbooghost/Coding/cpl-webiste/src/components/shared/aside/Aside.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/turbooghost/Coding/cpl-webiste/src/components/shared/footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/turbooghost/Coding/cpl-webiste/src/components/shared/fraud-banner/FraudBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/turbooghost/Coding/cpl-webiste/src/components/ui/backToTop/BackToTop.tsx");
